import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-agregados',
  templateUrl: './consulta-agregados.component.html',
  styleUrls: ['./consulta-agregados.component.scss']
})
export class ConsultaAgregadosComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() {
  }

  ngOnInit() {}

  ngOnChanges() {

    if(this.consulta) {
      this.consulta.dataUltimaAtualizacao = this.consulta.dataUltimaAtualizacao || this.consulta.dtUltimaAtualizacao || null;
    }

  }

}
